<template>
  <ul v-show="visible"
      class="context-menu"
      :style="`top:${top}px;left:${left}px;z-index: ${zIndex}`"
      @click.stop>
    <li>
      <el-button type="text"
                 size="small"
                 disabled
                 v-show="checkedFiles.length > 1">已选择{{checkedFiles.length}}项
      </el-button>
    </li>
    <li>
      <el-button type="text"
                 size="small"
                 @click="modify()"
                 :disabled="readOnly || !(checkedFiles.length === 1 && checkedFiles[0].type === 'photo')">修改
      </el-button>
    </li>
    <li>
      <el-button type="text"
                 size="small"
                 @click="copy()"
                 :disabled="checkedFiles.length === 0">复制
      </el-button>
    </li>
    <li>
      <el-button type="text"
                 size="small"
                 @click="cutPaste()"
                 :disabled="!pasteMax || readOnly || cutPasteStageFiles.length === 0 || copyType !== type">剪贴
      </el-button>
    </li>
    <li>
      <el-button type="text"
                 size="small"
                 @click="paste()"
                 :disabled="!pasteMax || readOnly || stageFiles.length === 0 || copyType !== type">粘贴
      </el-button>
    </li>
    <li>
      <el-button type="text"
                 size="small"
                 @click="remove()"
                 :disabled="readOnly || checkedFiles.length === 0">删除
      </el-button>
    </li>
    <li>
      <el-button type="text"
                 size="small"
                 @click="download()"
                 :disabled="checkedFiles.length === 0">下载
      </el-button>
    </li>
  </ul>
</template>

<script>
import download from 'downloadjs'
import cropperImage from '../../CropperImage'
export default {
  components: {},
  mixins: [],
  data () {
    return {
      request: null,
      name: null,
      callback: Function.prototype,
      visible: false,
      type: null,
      copyType: null,
      files: [], // 当前操作的数据列表
      copySourceFiles: [], // 拷贝数据的来源列表
      checkedFiles: [], // 选中的数据列表
      stageFiles: [], // 因为操作暂存的数据列表
      cutPasteStageFiles: [], // 因为剪切操作暂存的数据列表
      top: 0,
      left: 0,
      parentElement: document.body,
      zIndex: 0,
      uploadData: {},
      uploadApi: 'uploadOrderReviewDirectFile',
      scope: '',
      readOnly: false,
      pasteMax: Number.MAX_SAFE_INTEGER,
    }
  },
  computed: {},
  watch: {
    visible (val) {},
  },
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  destroyed () {},
  methods: {
    setScope (scope) {
      this.scope = scope
    },
    setType (type) {
      this.type = type
    },
    setFiles (files = []) {
      this.files = files
    },
    setCopyType (type) {
      this.copyType = type
    },
    setStageFiles (files = []) {
      // 清空数据
      this.stageFiles.splice(0, this.stageFiles.length)
      this.cutPasteStageFiles.splice(0, this.cutPasteStageFiles.length)
      // 暂存数据
      this.stageFiles.push.apply(this.stageFiles, files)
      // 允许裁剪时
      if (!this.readOnly) {
        this.cutPasteStageFiles.push.apply(this.cutPasteStageFiles, files)
      }

      // TODO: 为了二维码的复制 这里暂时存到本地
      if (this.type === 'photo') {
        localStorage.setItem('copyForQrcode', JSON.stringify(files))
      }

      // TODO: 为了切换审核历史也能发复制 这里暂时存到本地
      localStorage.setItem('copyForReloadReviewData', JSON.stringify(files))
      localStorage.setItem('copyForReloadReviewDataType', this.type)
    },
    appendElement (element) {
      // 置入的父级容器
      if (element.constructor === String) {
        element = document.querySelector(element)
      }
      if (this.parentElement !== element) {
        this.parentElement = element
        this.parentElement.appendChild(this.$el)
      }
    },
    show (left, top) {
      // 获得容器的相对屏幕的位置信息
      let position = this.parentElement.getBoundingClientRect()
      // 获得绝对坐标
      this.top = top - position.top + this.parentElement.scrollTop - 2
      this.left = left - position.left + this.parentElement.scrollLeft + 2
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    checked (file) {
      let index = this.checkedFiles.indexOf(file)
      if (index === -1) {
        this.checkedFiles.push(file)
      } else {
        this.checkedFiles.splice(index, 1)
      }
    },
    empty () {
      this.checkedFiles.splice(0, this.checkedFiles.length)
    },
    // 获取blob的文件后缀
    getExtByBlob (blob) {
      return blob.type.split('/').pop()
    },
    modify () {
      let file = this.checkedFiles[0]
      cropperImage({
        url: file.src,
        callback: async (blob, exif) => {
          let params = {
            orderid: this.uploadData.orderid,
            ext: this.getExtByBlob(blob),
            content_type: blob.type,
          }
          const res = await request.common(this.uploadApi, params)
          if (res.status === 200) {
            let uploadUrl = res.data.signedUrl
            let contentType = res.data.content_type
            let fileUrl = res.data.url
            await fetch(uploadUrl, {
              method: 'PUT',
              headers: new Headers({
                'Content-Type': contentType
              }),
              body: blob,
            })
            file.src = fileUrl
          } else {
            this.$message.error('图片保存失败')
          }
        },
      })
      // this.copySourceFiles = this.files
      // this.setStageFiles(this.checkedFiles)
      this.empty()
      this.hide()
    },
    copy () {
      this.copyType = this.type
      this.copySourceFiles = this.files
      this.setStageFiles(this.checkedFiles)
      this.$message.success(`复制了${this.stageFiles.length}个选项`)
      this.empty()
      this.hide()
    },
    cutPaste () {
      if (this.stageFiles.length > this.pasteMax) {
        this.$message.error('剪贴失败，粘贴数量超出目标容量')
      } else {
        // 删除复制来源数据列表
        this.cutPasteStageFiles.forEach(file => {
          let index = this.copySourceFiles.indexOf(file)
          this.copySourceFiles.splice(index, 1)
        })
        // 添加复制的数据到当前列表
        const list = this.cutPasteStageFiles.filter(item => item.type === 'photo').map(item => item.src)
        if (this.type === 'qrcode' && list.length > 0) {
          this.pasteToQrcodeData(list)
        } else {
          this.files.push.apply(this.files, JSON.parse(JSON.stringify(this.cutPasteStageFiles)))
        }
        this.$message.success(`剪贴了${this.cutPasteStageFiles.length}个选项`)
        this.setStageFiles()
      }
      this.hide()
    },
    paste () {
      if (this.stageFiles.length > this.pasteMax) {
        this.$message.error('粘贴失败，粘贴数量超出目标容量')
      } else {
        const list = this.stageFiles.filter(item => item.type === 'photo').map(item => item.src)
        if (this.type === 'qrcode' && list.length > 0) {
          this.pasteToQrcodeData(list)
        } else {
          this.files.push.apply(this.files, JSON.parse(JSON.stringify(this.stageFiles)))
        }
        this.$message.success(`粘贴了${this.stageFiles.length}个选项`)
      }
      this.hide()
    },
    pasteToQrcodeData (list) {
      Promise.all(list.map(this.decodeQRFromFileUrl)).then(values => {
        const qrcodes = values.filter(value => value.length > 0)
        if (qrcodes.length > 0) {
          Promise.all(qrcodes.map(value => this.recognizeQrcodeData({ data: value, server_image_recognize: 0 }))).then(datas => {
            const files = datas.map((value, index) => {
              return {
                data: value.data,
                image_url: list[index],
                status: value.status,
                type: this.type,
                src: list[index]
              }
            })
            if (list.length > 0) {
              this.files.push.apply(this.files, files)
            }
          })
        } else {
          this.$message.error('无法识别二维码信息')
        }
      })
    },
    remove () {
      this.$confirm(`此操作将删除${this.checkedFiles.length}项文件, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.checkedFiles.forEach(file => {
          let index = this.files.indexOf(file)
          this.files.splice(index, 1)
        })
        this.empty()
        this.$message.success('删除成功!')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
      this.hide()
    },
    download () {
      this.checkedFiles.forEach(({src}) => {
        download(filter.ossHost(src))
      })
      this.empty()
      this.hide()
    },

    // 识别二维码服务
    async decodeQRFromFileUrl (fileUrl) {
      const res = JSON.parse(await request.common('getQrcodeContentData', {url: fileUrl}).then(res => res.data))
      if (res.code === 0 && res.data.contents && res.data.contents.length > 0) {
        return res.data.contents[0]
      }
      return ''
    },
    async recognizeQrcodeData (data) {
      return request.common('getRecognizeQrcodeData', data).then(res => res.data)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
.context-menu {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  position: absolute;
  border-radius: 3px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 0px;
  list-style-type: none;

  li {
    &:first-child {
      border-radius: 3px 3px 0px 0px;
    }

    &:last-child {
      border-radius: 0px 0px 3px 3px;
      border-bottom-width: 0px;
    }

    &:hover {
      background-color: rgba(235, 238, 245, 0.95);
    }

    border-bottom: 1px solid #f2f6fc;
  }

  button {
    padding: 5px 10px;
    width: 100%;
    text-align: left;
  }

  small {
    color: rgb(192, 196, 204);
    font-weight: normal;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/ContextMenu/src/main.vue